import React, { useState } from 'react'
import { Tooltip, IconButton, Dialog } from '@material-ui/core'
import DialogView from '../../../Dialogos/DialogView'
import DeleteIcon from '@material-ui/icons/Delete'
import { connect } from 'react-redux'
import { eliminarDetalleCarga } from '../../actions/TablaCargaBuquesActions'
import { DialogConfirmacionContent } from '../../../Dialogos/DialogConfirmacionContent'

function EliminarCarga (props) {
  const { data, eliminarDetalleCarga } = props
  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleDelete = () => {
    eliminarDetalleCarga(data.fechaAnuncio, data.fechaDeCarga, data.exportador, data.claveCereal)
    handleClose()
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='lg'
      >
        <DialogView
          cancelCallback={handleClose}
          confirmCallback={handleDelete}
          title='Eliminar detalle de carga'
          content={<DialogConfirmacionContent message='¿Esta seguro que desea eliminar el detalle de carga?' />}
        />
      </Dialog>
      <Tooltip title={'Eliminar'}>
        <IconButton onClick={handleOpen} style={{ outline: 'none' }}>
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    </>
  )
}

const mapActionsToProps = {
  eliminarDetalleCarga
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(EliminarCarga)
